import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { gameQuality } from 'src/app/modules/main-game/constants/interfaces';
import { IRestoreBoostingCharacterCards } from '../action-modal/modals/energy-restoring/energy-restoring.component';
export interface ILocalCardStructure {
  displayName: string;
  mainImage: string;
  typeIcon: string;
}
interface IMultiple {
  chance?: number;
  id?: number;
  quantity?: number;
  sequenceNumber?: number;
}
@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent implements OnInit {
  @Input() isCardAnimation: boolean = false;
  @Input() animationCardImage: string | undefined;
  @Input() cardTitle: string | undefined | any;
  @Input() cardBackground: gameQuality | string | undefined;
  @Input() rightIcon: string | undefined;
  @Input() centerElement: string | undefined;
  @Input() leftIcon: string | undefined;
  @Input() fontSize?: number | any;
  @Input() quanity?: number;
  @Input() sellPrice?: number;
  @Input() multiple?: IMultiple;
  @Input() multipleCondition?: string;
  @Input() typeCard?: string;
  @Input() cardHolder?: IRestoreBoostingCharacterCards;
  @Input() cardSize?: { width?: string; height?: string; iconSize?: string };
  @Input() disabled?: boolean | undefined;
  @Input() public cardType:
    | 'LANDLICENSE'
    | 'BUILDINGLICENSE'
    | 'HIRINGLICENSE'
    | 'TESTCARD'
    | undefined;

  public cards: {
    LANDLICENSE: ILocalCardStructure;
    BUILDINGLICENSE: ILocalCardStructure;
    HIRINGLICENSE: ILocalCardStructure;
  } = {
    LANDLICENSE: {
      displayName: 'LAND LICENSE',
      mainImage: 'assets/cards/card-component/Land License(Hex).png',
      typeIcon: 'assets/cards/card-elements/Building icon 1.png',
    },
    BUILDINGLICENSE: {
      displayName: 'BUILDING LICENSE',
      mainImage: 'assets/cards/card-component/Building license1(Hex).png',
      typeIcon: 'assets/cards/card-elements/land icon 1.png',
    },
    HIRINGLICENSE: {
      displayName: 'HIRING LICENSE',
      mainImage: 'assets/cards/card-component/character(card).png',
      typeIcon: 'assets/cards/card-effects/character.png',
    },
  };

  public acceleratorConfig: {
    firstName: string;
    secondName: string;
    fontSizeTime: string;
  } = {
    firstName: '',
    secondName: '',
    fontSizeTime: '',
  };

  constructor() {}
  ngOnInit() {
    if (this.typeCard === 'ACCELERATOR') {
      const display = this.cardTitle?.split(' ');
      this.acceleratorConfig['firstName'] = display[0];
      this.acceleratorConfig['secondName'] = display.slice(1).join(' ');
      this.acceleratorConfig['fontSizeTime'] = (this.fontSize / 1.3).toFixed(1);
    }
    if (this.cardTitle?.length >= 15 && this.typeCard !== 'ACCELERATOR') {
      this.fontSize = this.fontSize / 1.2;
    }
  }

  public getContent(field: 'displayName' | 'mainImage' | 'typeIcon'): string {
    if (this.cardType && this.cardType !== 'TESTCARD') {
      return this.cards[this.cardType][field];
    } else {
      return '';
    }
  }
  public playVideo(event: any, type: 'play' | 'stop'): void {
    if (type === 'play') {
      event.srcElement.play();
    } else {
      event.srcElement.currentTime = 0;
      event.srcElement.pause();
    }
  }
}
